import React from 'react';
import '../../styles/components/AsperaEmptyState.scss';
import { ImageEmptyFilterState } from '../../svg/ImageEmptyFilterState';
import { tracking } from '../../services/TrackingService';
import { ImageEmptyState } from '../../svg/ImageEmptyState';
import { ImageEmptyStateDark } from '../../svg/ImageEmptyStateDark';
import { Button, Link } from '../Carbon';
import { SubManager } from '../../classes/SubManager';
import { AsperaError } from '../../classes/AsperaError';
/**
 * React Component
 *
 * The AsperaEmptyState provides the empty state design for rendering on the UI (mostly in DataTable)
 *
 * @example
 * ```javascript
 * <AsperaEmptyState title={'My title'} body={'My body text'} />
 * ```
 */
export class AsperaEmptyState extends React.Component {
    constructor() {
        super(...arguments);
        this.subManager = new SubManager();
    }
    get emptyStateImage() {
        const { emptyByFilter, customImage } = this.props;
        if (emptyByFilter) {
            return React.createElement(ImageEmptyFilterState, null);
        }
        if (customImage) {
            return customImage;
        }
        return tracking.currentTheme === 'g100' ? React.createElement(ImageEmptyStateDark, null) : React.createElement(ImageEmptyState, null);
    }
    componentDidMount() {
        this.subManager.setSubscription(tracking.themeChange.subscribe({
            next: () => {
                this.setState({});
            },
            error: error => {
                new AsperaError('AsperaEmptyState: unable to track theme change', error);
            },
        }));
    }
    componentWillUnmount() {
        this.subManager.unsubscribeAll();
    }
    render() {
        const { title, body, className, links, buttons } = this.props;
        return (React.createElement("div", { className: `aspera-empty-state ${className ? className : ''}`, "data-auto": "aspera-empty-state" },
            React.createElement("div", { className: "image-area" }, this.emptyStateImage),
            React.createElement("div", { className: "text-area" },
                React.createElement("div", { className: "primary-text" }, title),
                !!body && React.createElement("div", { className: "secondary-text" }, body)),
            Array.isArray(buttons) && buttons.filter(button => !button.hidden).map((button, index) => React.createElement("div", { className: "button", key: index },
                React.createElement(Button, { kind: button.kind, renderIcon: button.icon, "data-auto": `error-state-${button.name}`, onClick: button.onClick }, button.name))),
            Array.isArray(links) && links.map((link, index) => React.createElement("div", { className: "link", key: index },
                React.createElement(Link, { onClick: link.onClick }, link.name)))));
    }
}
